import { Fancybox } from '@fancyapps/ui';

export default function initLightbox() {
	initVideoLightbox();
}

function initVideoLightbox() {
	// only operate on customer experience page

	const trigger = document.querySelector( '.play-trigger' );

	if ( ! trigger ) return;

	// add click listener to trigger
	trigger.addEventListener( 'click', () => {
		new Fancybox( [
			{
				src: trigger.dataset.videoLink,
			},
		] );
	} );
}

